import React from 'react';

import { faComments } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import EmailQuoteValidates from 'pu-react/components/EmailQuoteValidates';
import PriceMatrix from 'shared/product_tabs/tab_assembly/components/price/us/PriceMatrix';
import LeadTimeRestrictions from 'shared/product_tabs/tab_assembly/components/price/us/LeadtimeRestrictions';

const Prices = (props) => {
  const {
    parameters,
    quote,
    quoteStep,
    parametersChanged,
    onPriceSelect,
    onSendEmailQuote,
    toggleLeadTimeRestrictions,
  } = props;

  return (
    <>
      <div className="price-matrices">
        <div className="price-matrix">
          <div className="d-flex justify-content-between my-2">
            <h2 className="title text-uppercase d-inline-block">USA PCB Assembly</h2>
            <div className="d-inline-block">
              <EmailQuoteValidates
                quoteStep={quoteStep}
                parametersChanged={parametersChanged}
                parameters={parameters}
                onSendEmailQuote={onSendEmailQuote} />
            </div>
          </div>
          <PriceMatrix
            quote={quote}
            parametersChanged={parametersChanged}
            onPriceSelect={onPriceSelect}
            parameters={parameters}
            quoteStep={quoteStep} />
          <div>
            <p className="mb-0">
              <FontAwesomeIcon icon={faComments} id="custom-quote-icon" />
              &nbsp; If you could not get an online price you can request a &nbsp;
              <a className="link" href={Spree.routes.custom_quote_request_new_url}>custom quote</a>.
            </p>
          </div>
        </div>
      </div>
      <LeadTimeRestrictions toggle={toggleLeadTimeRestrictions} />
    </>
  );
}

export default Prices;